<template>
  <!-- eslint-disable -->
  <div class="container">
    <main class="content">
      <!-- Post Generation Form -->
      <section class="post-generation">
        <div class="prompts_container">
          <div class="text-group-first">
            <span class="type-span">Choose A Post Type</span>
            <select v-model="selectedCategory" class="select">
              <option selected value="Famous Quotes">Famous Quotes</option>
              <option value="Educational Content">Educational Content</option>
              <option value="Seasonal-Holiday Posts">Seasonal/Holiday Posts</option>
              <option value="Engagement Posts">Engagement Posts</option>
              <option value="Fun Facts">Fun Facts</option>
              <option value="Humorous Posts">Humorous Posts</option>
              <option value="Quote of the Day">Quote of the Day</option>
              <option value="Interactive Content">Interactive Content</option>
            </select>
          </div>
          <div class="text-group">
            <span class="type-span">Additional Instructions (not required)</span>
            <textarea v-model="additionalInfo" type="text" class="input-text"
                      placeholder="Provide additional information to further refine the post."></textarea>
          </div>
        </div>
        <b-button variant="success" @click="generatePost" :disabled="loading">
          <span>Generate Post</span>
        </b-button>
      </section>

      <b-modal v-model="showSocialPostModal"
        :title="fusionPostModalTitle">
        <div v-if="postingItem">
          <p class="mb-3">{{ fusionPostConfirmMessage(postingType) }}</p>
          <div><strong>Post Text: </strong>
            <!-- eslint-disable-next-line -->
            <span v-html="socialPostToDisplayHtml(postingItem.text)"></span>
          </div>
          <div v-if="postingType === 'instagram' && postingItem.instagram_post" class="mt-3">
            Posted to Instagram on {{ postingItem.instagram_post.front_date }}<br />
            Link: <a :href="'https://www.instagram.com/p/' + postingItem.instagram_post.ig_shortcode"
              target="_blank">https://www.instagram.com/p/{{ postingItem.instagram_post.ig_shortcode }}</a>
          </div>
          <div v-if="postingType === 'facebook' && postingItem.facebook_post" class="mt-3">
            Posted to Facebook on {{ postingItem.facebook_post.front_date }}<br />
            Link: <a :href="'https://www.facebook.com/' + postingItem.facebook_post.post_id"
              target="_blank">https://www.facebook.com/{{ postingItem.facebook_post.post_id }}</a>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="danger" @click="showSocialPostModal = false">Cancel</b-button>
          <b-button variant="success" @click="postSocial(postingItem, postingType)"><b-spinner
              v-if="postingItem.working" small /> Post</b-button>
        </template>
      </b-modal>

      <div class="modal_container review_post_modal_wrapper fade" id="review_post_modal">
        <div class="review_post_modal">
          <span id="modal_close" class="modal_close_icon" @click="fadeOut">&times;</span>
          <div class="modal_content_wrapper">
            <div class="modal_content">
              <div class="post_content">
                <div class="post">
                  <div v-if="loading" class="loading_div">
                    <h2 class="generate">Generating Post!</h2>
                    <b-spinner class="spin" large></b-spinner>
                  </div>
                  <div v-else>
                    <div class="post_text_wrapper">
                      <p id="post_text" class="post_text editable_text" dir="ltr" contenteditable @input="updatePostText" v-html="socialPostToDisplayHtml(newPost.text)"></p>
                      <br>
                      <p id="post_tags" class="post_tags editable_text" dir="ltr" contenteditable @input="updatePostHashtags" v-html="socialPostToDisplayHtml(newPost.hashtags)"></p>
                    </div>
                    <div class="post_image_wrapper">
                      <img id="post_image" :src="newPost.imageUrl" alt="" class="post_image" />
                    </div>
                  </div>
                </div>
                <button v-if="!loading" class="edit_post_button" id="edit_post" @click="editPost">Edit</button>
              </div>
              <div v-if="!loading" class="regenrate_buttons_container">
                <b-button variant="success" class="regenerate_btn"  @click="regenerate('image')" :disabled="loadingImage">
                  <b-spinner v-if="loadingImage" small></b-spinner>
                  <span>Regenerate Image</span>
                </b-button>
                <b-button variant="success" class="regenerate_btn"  @click="regenerate('post')" :disabled="loadingPost">
                  <b-spinner v-if="loadingPost" small></b-spinner>
                  <span>Regenerate Post</span>
                </b-button>
              </div>
              <div v-if="!loading" class="social_media_buttons_container">
                <b-button variant="success" class="social_post_btn" @click="postSocial(null, 'facebook')" :disabled="loadingFacebook">
                  <b-spinner v-if="loadingFacebook" small></b-spinner>
                  <span>Post To Facebook</span>
                </b-button>
                <b-button variant="success" class="social_post_btn" @click="postSocial(null, 'instagram')" :disabled="loadingInstagram">
                  <b-spinner v-if="loadingInstagram" small></b-spinner>
                  <span>Post To Instagram</span>
                </b-button>
                <b-button variant="success" class="social_post_btn" @click="postSocial(null, 'instagram', true)" :disabled="loadingFbIg">
                  <b-spinner v-if="loadingFbIg" small></b-spinner>
                  <span>Post To FB & IG</span>
                </b-button>
                <b-button variant="success" class="social_post_btn" @click="postSocial(null, 'google')" :disabled="loadingGbp">
                  <b-spinner v-if="loadingGbp" small></b-spinner>
                  <span>Post To Google</span>
                </b-button>
              </div>
            </div>
          </div>
          <button v-if="!loading" class="save_btn" id="save_btn" @click="saveNewPost">Save</button>
        </div>
      </div>

      <!-- Recent Posts -->
      <section v-if="posts.length" class="recent-posts">
        <h2 class="section-title">Recent Posts</h2>
        <div v-for="post in posts" :key="post.date" class="recentPost">
          <div class="post-header">
            <span class="post-title" v-html="socialPostToDisplayHtml(post.text)"></span>
            <span class="post-title" v-html="socialPostToDisplayHtml(post.hashtags)"></span>
            <div class="post-buttons">
              <div class="buttonspan">
                <b-button v-if="user.business.facebook_token && user.business.facebook_token.fb_page_id" size="sm"
                  :class="{ 'bg-success': post.facebook_post, 'border-success': post.facebook_post }"
                  class="post-btn mt-2 mr-2 bg-primary border-primary" @click="confirmPostSocial(post, 'facebook')">
                  <span v-if="post.facebook_post">Posted</span><span v-else>Post</span> to Facebook
                </b-button>
                <span v-if="post.facebook_post" class="formatteddate">{{ formattedDate(post) }}</span>
              </div>
              <div class="buttonspan">
                <b-button v-if="user.business.facebook_token && user.business.facebook_token.ig_identifier" size="sm"
                  :class="{ 'bg-success': post.instagram_post, 'border-success': post.instagram_post }"
                  class="post-btn mt-2 mr-2 bg-primary border-primary" @click="confirmPostSocial(post, 'instagram')">
                  <span v-if="post.instagram_post">Posted</span><span v-else>Post</span> to Instagram
                </b-button>
                <span v-if="post.instagram_post" class="formatteddate">{{ formattedInstagramDate(post) }}</span>
              </div>
              <div class="buttonspan">
                <b-button v-if="user.business.location_id" size="sm"
                          :class="{ 'bg-success': post.gbp_post, 'border-success': post.gbp_post }"
                          class="post-btn mt-2 bg-primary border-primary" @click="confirmPostSocial(post, 'google')">
                  <span v-if="post.gbp_post">Posted</span><span v-else>Post</span> to Google
                </b-button>
                <span v-if="post.gbp_post" class="formatteddate">{{ formattedInstagramDate(post) }}</span>
              </div>
            </div>
          </div>
          <img :src="post.imageUrl" alt="Generated Image" class="post-image">
        </div>
        <div class="load-div">
          <button v-if="hasMorePosts"
            class="btn post-btn mt-2 mr-2 bg-primary border-primary btn-secondary btn-lr load-more-btn"
            @click="loadMore">Load
            More</button>
        </div>
      </section>
      <b-modal  content-class="keymodal" v-model="showConnectAlert">
        <p><strong>Important:</strong> Connect Your Social Media Accounts</p>
        <p>To start automating your social media content, please connect your social media accounts.</p>
        <p>Connecting your accounts ensures seamless content creation and scheduling, making your social media management effortless.</p>
        <b-button variant="primary" @click="gotoSettings">Connect Your Accounts</b-button>
      </b-modal>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  fusionPostModalTitle,
  fusionPostConfirmMessage,
  socialPostPlatformName,
  socialPostToPlainText,
  socialPostToDisplayHtml,
} from '@utils/socialPostModal'
import { businessLimitForUser } from '@utils/businessLimitsFeature'
import { promptForCategory } from '@utils/socialFusionPrompts'

export default {
  name: 'SocialPosts',
  data() {
    return {
      selectedCategory: 'Famous Quotes',
      additionalInfo: '',
      posts: [],
      postingItem: null,
      postingType: '',
      showSocialPostModal: false,
      fusionPostModalTitle,
      loading: false,
      showModal: false,
      newPost: {
        text: '',
        imageUrl: '',
        hashtags: '',
        id: ''
      },
      loadedPostsCount: 2,
      hasMorePosts: true,
      loadingText: false,
      loadingImage: false,
      loadingPost: false,
      loadingFacebook: false,
      loadingInstagram: false,
      loadingGbp:false,
      loadingFbIg: false,
      showConnectAlert: false,
      overPostLimit:false
    };
  },

  computed: {
    formattedDate() {
      return (post) => {
        if (post && post.facebook_post && post.facebook_post.front_date) {
          const date = new Date(post.facebook_post.front_date);
          const options = {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          };
          return date.toLocaleString('en-US', options);
        } else {
          return ''; // Handle cases where the date is not available
        }
      };
    },
    formattedInstagramDate() {
      return (post) => {
        if (post && post.instagram_post && post.instagram_post.front_date) {
          const date = new Date(post.instagram_post.front_date);
          const options = {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          };
          return date.toLocaleString('en-US', options);
        } else {
          return ''; // Handle cases where the date is not available
        }
      };
    },
  },

  mounted() {
    this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
    this.fetchPosts();
    this.loading = false;

    const token = this.$route.params.token;
    if (token) {
      const type = this.$route.params.type;
      if (type) {
        this.selectedCategory = type;
        this.additionalInfo = this.$route.params.add || '';
        this.generatePost();
      } else {
        this.loadApprovalEmailContext(token);
      }
    }

    if(this.user.google_accounts && this.user.google_accounts.length >= 1 && !this.user.business.facebook_token && this.user.business.is_social_fusion){
      setTimeout(() => {
        this.showConnectAlert = true;
      }, 250);
    }
  },

  methods: {
    fusionPostConfirmMessage,
    socialPostToDisplayHtml,
    loadApprovalEmailContext(token) {
      this.$store
        .dispatch('posts/getApprovalEmailContext', { token })
        .then((data) => {
          if (data?.post_type) {
            this.selectedCategory = data.post_type;
          }
          this.additionalInfo = data?.additional_instructions || '';
          this.generatePost();
        })
        .catch((err) => {
          const message = err.response?.data?.error || 'Unable to load approval email details.';
          Vue.$toast.open({ message, type: 'error', duration: 5000, position: 'bottom' });
        });
    },
    gotoSettings() {
      window.location.href = "/business/settings";
    },
    editPost() {
      let elements = document.querySelectorAll('.editable_text');
      console.log(elements);
      elements.forEach(e => {
        if (e.getAttribute('contenteditable') === 'true') {
          e.setAttribute('contenteditable', 'false');
          e.style.border = 'none'
          e.style.padding = '0'
          e.style.whiteSpace = ''
          e.style.minHeight = ''
          e.style.resize = ''
          e.style.overflow = ''
          // Remove keydown event listener
          e.removeEventListener('keydown', this.handleEnterKey);
          document.getElementById('edit_post').innerHTML = "Edit";

        } else {
          e.setAttribute('contenteditable', 'true');
          e.style.border = '1px solid black'
          e.style.padding = '2px'
          e.style.whiteSpace = 'pre-wrap' // Allow multiline and preserve line breaks
          e.style.minHeight = '60px' // Minimum height for multiline editing
          e.style.resize = 'vertical' // Allow vertical resizing
          e.style.overflow = 'auto' // Show scrollbar if content overflows
          e.style.wordWrap = 'break-word' // Break long words
          e.style.overflowWrap = 'break-word' // Break words at appropriate points
          // Add keydown event listener for Enter key
          e.addEventListener('keydown', this.handleEnterKey);
          document.getElementById('edit_post').innerHTML = "Done";
        }
      });
      
      const isDisablingEdit = document.querySelector('.editable_text[contenteditable="true"]') === null;
      if (isDisablingEdit) {
        this.syncEditablePostFromDom();
      }
    },
    syncEditablePostFromDom() {
      const postTextEl = document.getElementById('post_text');
      const postTagsEl = document.getElementById('post_tags');
      if (postTextEl) {
        this.newPost.text = socialPostToPlainText(postTextEl.innerHTML);
      }
      if (postTagsEl) {
        this.newPost.hashtags = socialPostToPlainText(postTagsEl.innerHTML);
      }
    },
    handleEnterKey(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        
        // Use execCommand for reliable line break insertion
        // This is the standard way browsers handle line breaks in contenteditable
        const success = document.execCommand('insertLineBreak', false, null);
        
        if (!success) {
          // Fallback to manual insertion if execCommand fails
          const selection = window.getSelection();
          if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            
            // Insert line break
            const br = document.createElement('br');
            range.insertNode(br);
            
            // Ensure br is visible by adding a text node after it if at the end
            if (!br.nextSibling) {
              const textNode = document.createTextNode('');
              br.parentNode.insertBefore(textNode, br.nextSibling);
              range.setStart(textNode, 0);
              range.collapse(true);
            } else {
              range.setStartAfter(br);
              range.collapse(true);
            }
            
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }
        
        // Don't update the model here - we'll sync when editing is done
        // This prevents Vue from re-rendering and resetting the cursor
        return false;
      }
    },
    updatePostText(event) {
      const el = event.target;
      // Don't update the model during editing to prevent Vue re-rendering
      // which causes cursor position to reset
      // The content is already in the DOM, we'll sync it when editing is done
      if (el.getAttribute('contenteditable') === 'true') {
        // Only update if we're not in the middle of handling Enter key
        // The handleEnterKey will update the model
        return;
      }
      
      // Store plain text so Instagram/Facebook captions never receive HTML
      this.newPost.text = socialPostToPlainText(el.innerHTML);
    },
    updatePostHashtags(event) {
      const el = event.target;
      // Don't update the model during editing to prevent Vue re-rendering
      // which causes cursor position to reset
      if (el.getAttribute('contenteditable') === 'true') {
        return;
      }
      
      // Store plain text so Instagram/Facebook captions never receive HTML
      this.newPost.hashtags = socialPostToPlainText(el.innerHTML);
    },
    restoreSelection(el, startOffset, endOffset) {
      const range = document.createRange();
      const sel = window.getSelection();
      range.setStart(el.firstChild, startOffset);
      range.setEnd(el.firstChild, endOffset);
      sel.removeAllRanges();
      sel.addRange(range);
    },
    handleInput(el) {
      this.$nextTick(() => {
        this.placeCaretAtEnd(el);
      });
    },
    placeCaretAtEnd(el) {
      el.focus();
      if (typeof window.getSelection !== "undefined" && typeof document.createRange !== "undefined") {
        let range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        let sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (typeof document.body.createTextRange !== "undefined") {
        let textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
      }else{
        console.error("neither if nor else")
      }
    },
    fadeOut() {
      let duration = 250;
      let element = document.getElementById('review_post_modal');

      element.style.transition = `opacity ${duration}ms`;
      element.style.opacity = 0;

      setTimeout(() => {
        element.style.display = 'none';
        element.classList.remove('show');
      }, duration);
    },
    loadMore() {
      this.loadedPostsCount += 2;
      this.fetchPosts();
    },
    confirmPostSocial(post, type) {
      this.postingItem = post;
      this.postingType = type;
      this.showSocialPostModal = true;
    },

    regenerate(type) {
      if (type === 'text') this.loadingText = true;
      if (type === 'image') this.loadingImage = true;
      if (type === 'post') this.loadingPost = true;

      let action = '';
      const prompt = this.generatePrompt();

      if (type === 'text') {
        action = 'posts/regenerateText';
      } else if (type === 'image') {
        action = 'posts/regenerateImage';
      } else if (type === 'post') {
        action = 'posts/regeneratePost';
      }

      this.$store.dispatch(action, {
        prompt: prompt,
        business_id: this.user.business.id,
        text: this.newPost.text,
        additional_info: this.additionalInfo,
      })
        .then(response => {
          if (response) {
            if (type === 'text' || type === 'post') {
              this.newPost.text = response.text;
              this.newPost.hashtags = response.hashtags;
            }
            if (type === 'image' || type === 'post') {
              this.newPost.imageUrl = response.imageUrl;
            }
          }
        })
        .catch(error => {
          console.error('Error regenerating:', error);
          this.loading = false;
        })
        .finally(() => {
          if (type === 'text') this.loadingText = false;
          if (type === 'image') this.loadingImage = false;
          if (type === 'post') this.loadingPost = false;
        });
    },

    postSocial(post, type, both = false) {
      if (type === 'google') both = false;
      if (type === 'facebook') this.loadingFacebook = true;
      if (type === 'instagram' && !both) this.loadingInstagram = true;
      if(type === 'google') this.loadingGbp = true;
      if (both) this.loadingFbIg = true;

      post = post || this.newPost;
      this.$set(post, 'working', true); // Use Vue's set method

      const postToSocialMedia = (type) => {
        return this.$store.dispatch('posts/postSocial', {
          type: type,
          post_id: post.id,
          user_id: this.user.id,
          business_id: this.user.business.id
        });
      };

      this.saveNewPost(false)
        .then(() => {
          post = post || this.newPost;
          if (both) {
            // First post to Instagram, then to Facebook
            postToSocialMedia('instagram')
              .then((res) => {
                this.$set(post, 'instagram_post', res.instagram_post);
                return postToSocialMedia('facebook');
              })
              .then((res) => {
                this.$set(post, 'facebook_post', res.facebook_post);
                this.$set(post, 'working', false);
                this.fadeOut();
                this.fetchPosts();
                alert('Post has been successfully posted to Instagram and Facebook!');
                this.showSocialPostModal = false;
              })
              .catch((res) => {
                this.$set(post, 'working', false);
                console.log(res);
              })
              .finally(() => {
                this.loadingFbIg = false;
                this.showSocialPostModal = false;
              });
          } else {
            // Post to the specified type
            postToSocialMedia(type)
              .then((res) => {
                if (type === 'facebook') {
                  this.$set(post, 'facebook_post', res.facebook_post);
                } else if (type === 'instagram') {
                  this.$set(post, 'instagram_post', res.instagram_post);
                } else if (type === 'google') {
                  this.$set(post, 'gbp_post', res.gbp_post);
                }
                this.$set(post, 'working', false);
                this.fadeOut();
                this.fetchPosts();
                alert(`Post has been successfully posted to ${socialPostPlatformName(type)}!`);
                this.showSocialPostModal = false;
              })
              .catch((res) => {
                this.$set(post, 'working', false);
                console.log(res);
              })
              .finally(() => {
                if (type === 'facebook') this.loadingFacebook = false;
                if (type === 'instagram' && !both) this.loadingInstagram = false;
                if(type === 'google') this.loadingGbp = false;
                this.showSocialPostModal = false;
              });
          }
        })
        .catch((err) => {
          this.$set(post, 'working', false);
          console.log(err);
        });
    },

    generatePost() {
      if(this.overPostLimit){
        Vue.$toast.open({message: "Sorry, but you have reached your monthly post limit", type: 'error', duration: 5000, position: 'bottom'});
        return
      }
      const prompt = this.generatePrompt();
      this.loading = true;
      let element = document.getElementById('review_post_modal');

      element.style.opacity = 0;
      element.style.display = 'grid';
      element.style.alignItems = 'center';
      element.style.transition = `opacity 250ms`;

      requestAnimationFrame(() => {
        element.style.opacity = 1;
      });

      setTimeout(() => {
        element.classList.add('show');
      }, 250);

      this.$store
        .dispatch('posts/generatePost', {
          prompt: prompt,
          additional_info: this.additionalInfo,
          user_id: this.user.id,
          business_id: this.user.business.id,
        })
        .then((res) => {
          if (res) {
            const reply = res;

            this.newPost = {
              text: reply.text,
              hashtags: reply.hashtags,
              imageUrl: reply.imageUrl,
              date: new Date().toLocaleString(),
            };

            this.updateModalContent();
          }
        })
        .catch((err) => {
          Vue.$toast.open({message: err.response.data.error, type: 'error', duration: 5000, position: 'bottom'});
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateModalContent() {
      // This method updates the modal content with the generated post
      let postTags = document.getElementById('post_tags');
      let postImage = document.getElementById('post_image');
      let postText = document.getElementById('post_text');

      postTags.innerHTML = socialPostToDisplayHtml(this.newPost.hashtags);
      postText.innerHTML = socialPostToDisplayHtml(this.newPost.text);
      postImage.src = this.newPost.imageUrl;
    },

    saveNewPost(fade=true) {
      return new Promise((resolve, reject) => {
        this.syncEditablePostFromDom();
        if (this.newPost.text !== "" && this.newPost.text) {
          this.$store
            .dispatch('posts/savePost', {
              user_id: this.user.id,
              business_id: this.user.business.id,
              hashtags: this.newPost.hashtags,
              text: this.newPost.text,
              image_url: this.newPost.imageUrl,
            })
            .then((res) => {
              this.newPost.id = res.id;
              if (!this.posts.some(post => post.id === this.newPost.id)) {
                  this.posts.unshift(this.newPost);
              }
              resolve(res);
              if(fade){
                this.fadeOut();
                alert('Post has been successfully saved.');
              }
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        } else {
          resolve('done');
        }
      });
    },

    generatePrompt() {
      return promptForCategory(this.selectedCategory);
    },

    fetchPosts() {

      // console.log(this.generatePrompt())

      this.$store
        .dispatch('posts/getPosts', {
          user_id: this.user.id,
          business_id: this.user.business.id,
          limit: this.loadedPostsCount // Limit the number of posts fetched
        })
        .then((res) => {
          if (res.data.length < this.loadedPostsCount) {
            // If fetched posts count is less than requested, assume no more posts available
            this.hasMorePosts = false;
          }
          const monthlyLimit = businessLimitForUser(this.user, 'social_fusion_post_limit');
          if (monthlyLimit != null && res.posts_this_month >= monthlyLimit) {
            this.overPostLimit = true;
          }
          this.posts = res.data.map(post => {
            if(post.image_url)
              post.imageUrl = post.image_url.replace(/\\\//g, '/');
            return post;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>

.prompts_container{
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  @media (max-width: 992px) {
    flex-wrap: wrap;
  }
}

.post-generation {
  align-items: flex-start;
  justify-content: space-between;
  display: grid;
  grid-template-columns: 4fr 1fr;
  //flex-direction: row;
  gap: 1rem;
  width: 100%;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.type-span {
  margin: 5px;
  font-weight: bold;
  color: #868686;
  font-size: 15px;
}

.input-group {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
}

.text-group-first {
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 100%;
  }
}

.text-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.select {
  width: 200px;
  padding: 10px;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}

.input-text {
  flex-direction: row;
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  height: 100px;
  border-radius: 20px;
  margin-right: 20px;
}

.generate-btn {
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
}

.generate-btn:disabled {
  background-color: #6c757d;
}

.loader {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loader {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.container {
  display: flex;
}

.content {
  flex: 1;
  padding: 32px;
  @media(max-width: 768px){
    padding: 20px 0;
  }
}

.content-page{
  padding: 0 !important;
}

.post-generation {
  margin-bottom: 32px;
}

.formatteddate {
  margin-top: 5px;
  font-size: 11px;
  font-weight: bold;
  color: red;
}

.buttonspan {
  display: flex;
  flex-direction: column;
}

.input-group {
  display: flex;
  margin-bottom: 16px;
}

.select {
  width: 100% !important;
  margin-right: 20px;
  border: 1px solid #ccc;
  padding: 8px;
  margin-right: 20px;
  padding: 10px;
  border-radius: 10px;
}

.input-text {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px;
  width: 100%;
}

.generate-btn {
  color: white;
  padding: 8px 40px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  margin-top: 30px !important;
}

.recent-posts .section-title {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 16px;
  margin-left: 20px;
  color: gray;
}

.recent-posts {
  background: white;
  padding: 30px;
  border-radius: 20px;
}

.recentPost {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  border: 1px solid lightgray;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 16px;
  @media(max-width: 992px){
    flex-wrap: wrap;
    padding: 3px;
    .post-image{
      order: 1;
      margin-inline: auto;
      width: 50%;
    }
    .post-header{
      order: 2;
    }
  }
}

.post-header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: 8px;
}

.post-title {
  font-size: 16px;
  margin-left: 20px;
  color: black;
}

.post-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  margin-left: 30px;
}

.post-btn {
  background-color: #28a745;
  color: white;
  padding: 4px 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.spin {
  height: 5rem;
  width: 5rem;
  margin-top: 20%;
  margin-left: 40%;
}

.generate {
  text-align: center;
  color: black;
}

.loading_div {
  height: 300px;
  width: 300px;
}

.post-image {
  margin: 8px 0;
  box-shadow: 3px 3px 10px #d7d7d7;
  width: 30%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: 4px;
}

.post-content {
  color: #6b7280;
  font-size: 14px;
}

.post-date {
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
}

.more-link {
  color: #007bff;
  text-decoration: none;
}

.load-more-btn {
  //width: 13%;
}

.load-div {
  justify-content: center;
  display: flex;
  margin-top: 10px;
}


.modal_container {
  min-width: 100vw;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  display: grid;
  justify-content: center;
  align-items: center;
}

.review_post_modal {
  background: #fff;
  height: 100%;
  max-height: 80vh;
  position: relative;
  overflow-y: scroll;
  padding: 1rem;

  .modal_close_icon {
    position: absolute;
    top: .5rem;
    right: .8rem;
    font-weight: 800;
    font-size: 2rem;
    cursor: pointer;
  }
  .modal_content_wrapper{
    padding: 2rem 4rem;
    @media (max-width: 768px){
      padding: 2rem 1rem;
    }
  }
  .modal_content {

    .post_content {
      max-width: 20rem;
      margin-inline: auto;
      margin-bottom: 1rem;
      position: relative;

      @media (max-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: flex-start;
        gap: .5rem;
      }

      .post_text_wrapper {
        background-color: #f2f2f2;
        padding: .5rem .8rem;
        margin-bottom: 5px;

        p {
          margin: 0;
        }
      }

      .post_image_wrapper {
        border: 1px solid gray;

        .post_image {
          width: 100%;
          aspect-ratio: 4 / 3;
          object-fit: cover;
        }
      }

      .edit_post_button {
        border: none;
        background: #284374;
        color: #fff;
        padding: .3rem 1rem;
        border-radius: 4px;
        cursor: pointer;

        @media (min-width: 768px) {
          position: absolute;
          left: 102%;
          top: 0
        }
      }
    }

    .regenrate_buttons_container {
      margin-bottom: .5rem;
      margin-inline: auto;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: .2rem;

      .regenerate_btn {
        margin-inline: .3rem;
        border: none;
        background: #06b050;
        color: #fff;
        padding: .3rem 1.5rem;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
      }
    }

    .social_media_buttons_container {
      margin-inline: auto;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: .2rem;

      .social_post_btn {
        margin-inline: .3rem;
        border: none;
        background: #284374;
        color: #fff;
        padding: .3rem .7rem;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }

  .save_btn {
    border: none;
    background: #284374;
    color: #fff;
    padding: .3rem 1rem;
    border-radius: 4px;
    float: inline-end;
    cursor: pointer;
  }
}

.fade {
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  display: none;
}

.fade.show {
  opacity: 1;
}
</style>

<style>
.keymodal .modal-body{
  text-align: center !important;
  font-size: 17px !important;
  color: black !important;
}
.keymodal .modal-footer{
  display: none !important;
}
.keymodal .btn{
  font-weight: bold;
  font-size: 17px;
}

@media (min-width: 768px) {

  #review_post_modal{
    padding-top: 4rem
  }
}


</style>
